<template>
  <v-dialog
    :model-value="true"
    persistent
    scrollable
    max-width="530px"
    class="no-print"
    @click:outside="emit('close')"
  >
    <v-form ref="form">
      <v-card>
        <v-toolbar color="primary" dark class="pl-6">
          <div class="d-flex flex-column">
            <span class="text-h6">
              Customizar Impressão do Borderô
            </span>
            <span class="text-caption">
              Apenas as tabelas e colunas selecionadas serão impressas
            </span>
          </div>
        </v-toolbar>
        <v-card-text style="height: auto">
          <v-expansion-panels multiple>
            <v-expansion-panel v-for="item in printing.items.filter(i => i.toggeable)" :key="item.id">
              <template #title>
                <v-switch
                  v-model="item.disabled"
                  class="mr-4"
                  color="primary"
                  density="compact"
                  hide-details
                  inset
                  @click.stop="item.children?.forEach(c => c.disabled = !item.disabled)"
                />
                <p class="flex-grow-1 font-weight-bold">
                  {{ item.title }} {{ item.disabled && item.children?.some(c => !c.disabled) ? '*' : '' }}
                </p>
              </template>
              <template #text>
                <div v-for="child, index in (item.children ?? []).filter(c => c.toggeable)" :key="index" class="d-flex align-center justify-center">
                  <v-switch
                    v-model="child.disabled"
                    class="mr-4"
                    color="primary"
                    density="compact"
                    hide-details
                    inset
                  />
                  <p class="flex-grow-1">
                    {{ child.title }}
                  </p>
                </div>
              </template>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red darken-1"
            variant="text"
            :disabled="loader.loading"
            @click="emit('close')"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            variant="text"
            :disabled="loader.loading"
            @click="printing.print(filename)"
          >
            Imprimir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script setup lang="ts">
import { eventName } from '@/plugins/eventName'
import { useLoader } from '@/stores/loader'
import { usePrintingStore } from '@/stores/printing'
import Event from '@/types/Event'
import { computed } from 'vue'

const printing = usePrintingStore()

interface Props {
  event: Event
}

const loader = useLoader()

const emit = defineEmits([ 'close' ])

const { event } = defineProps<Props>()

const filename = computed(() => eventName(event))

</script>
